import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';
import FormStyles from 'styles/mixins/Form.styles';

const StyledWizardContent = styled(Box)`
  .WizardContent {
    &-loader {
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      position: absolute;
      z-index: ${props => props.theme.property('zIndex.loader')};

      opacity: 0.8;
      background-color: ${props => props.theme.property('palette.background.default')};
    }
  }
  
  ${FormStyles}
  ${ComponentStyles}
`;

StyledWizardContent.propTypes = {
  theme: PropTypes.object
};

export default StyledWizardContent;
